import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AddRecipientModal } from '../../message-modals/add-recipient/add-recipient';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DataTableComponent } from '../../ui/data-table/data-table.component';

@Component({
  selector: 'add-organisation-modal',
  standalone: true,
  imports: [CommonModule, AddRecipientModal, FormsModule, ReactiveFormsModule, DataTableComponent],
  templateUrl: './add-organisation-component.html',
  styleUrls: ['./add-organisation-modal.css'],
})
export class AddOrganisationModal {
  @Input() data: any[] = []; // Pass data from parent
  @Input() add_recipient: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() selectedOrgsChange = new EventEmitter<any[]>();
  @Input() selectedOrg: any[] = [];

  // Form Control for search input
  searchControl = new FormControl('');

  // Track selected organisations and search query
  org_list: any[] = [];
  allSelectedOrg = false;
  searchParam: string = '';

  constructor(
    private router: Router,
    private contactsService: ContactsService
  ) {}

  // Close modal
  closeModal(): void {
    this.close.emit();
  }

  // Fetch organisations from service
  fetchOrganisations(): void {
    this.contactsService.fetchOrganizations({
      'name.contains': this.searchParam,
    });

    this.contactsService.getOrganizations.subscribe({
      next: (data) => {
        this.org_list = data.map((org) => ({
          ...org,
          selected: this.selectedOrg.some(
            (selected) => selected.uuid === org.uuid
          ),
        }));
      },
      error: (err) => {
      },
    });
  }

  // Update search query and fetch new organisations
  getSearchParam(searchTerm: string): void {
    this.searchParam = searchTerm;
    this.fetchOrganisations();
  }

  // Toggle selection of all organisations
  toggleAllTags(event: any): void {
    this.allSelectedOrg = event.target.checked;
    this.org_list.forEach((org) => {
      org.selected = this.allSelectedOrg;
    });
    this.updateSelectedOrgs();
  }

  // Update selected organisations based on checkbox state
  checkSelectionOrg(): void {
    this.updateSelectedOrgs();
  }

  // Update selectedOrg array and emit to parent component
  updateSelectedOrgs(): void {
    this.selectedOrg = this.org_list.filter((org) => org.selected);
    this.selectedOrgsChange.emit([...this.selectedOrg]); // Emit new reference
  }

  // Persist selected organisations to localStorage
  persistSelectedOrg(): void {
    localStorage.setItem('selectedOrg', JSON.stringify(this.selectedOrg));
  }

  // Load previously selected organisations from localStorage
  loadSelectedOrg(): void {
    const savedOrg = localStorage.getItem('selectedOrg');
    if (savedOrg) {
      this.selectedOrg = JSON.parse(savedOrg);

      this.org_list = this.org_list.map((org) => ({
        ...org,
        selected: this.selectedOrg.some(
          (selectedOrg) => selectedOrg.uuid === org.uuid
        ),
      }));
    }
  }

  // Filter data based on search term
  filterData(searchTerm: string, param = 'message_subject'): any[] {
    if (!searchTerm) {
      return this.data;
    }

    return this.data.filter((item) =>
      item[param].toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // Lifecycle method: ngOnInit
  ngOnInit(): void {
    this.fetchOrganisations();

    // Reactive search input listener
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: any) => {
        this.searchParam = value;
        this.fetchOrganisations();
      });

    // Load previously selected organisations
    this.loadSelectedOrg();
  }

  // // Lifecycle method: ngOnDestroy
  // ngOnDestroy(): void {
  //   this.persistSelectedOrg(); // Persist selected organisations on component destroy
  // }

  // Lifecycle method: ngOnChanges
  ngOnChanges(): void {
    // Update selected state of organisations when selectedOrg input changes
    this.org_list.forEach((org) => {
      org.selected = this.selectedOrg.some(
        (selectedOrg) => selectedOrg.uuid === org.uuid
      );
    });
  }
}
